import { render, staticRenderFns } from "./BBDiscount.vue?vue&type=template&id=94ef82aa&lang=pug"
import script from "./BBDiscount.vue?vue&type=script&lang=js"
export * from "./BBDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports